export default __webpack_public_path__ + "430c8517f5978aef5d68ef552e136796.svg";